
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-gray-100 rounded-full mb-12">
              <span className="text-xs font-semibold text-gray-600 uppercase tracking-wider">About Us</span>
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
              Expert Team Building
              <br />
              Premium iOS Solutions
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              KUBIK d.o.o. is a dedicated team of iOS development experts committed to creating innovative applications that prioritize user security and experience. Our expertise spans across VPN technology and device optimization, ensuring that every product we develop meets the highest standards of quality and performance.
            </p>
          </div>

          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-[2rem] p-12 relative overflow-hidden">
            <div className="absolute top-8 right-8 flex gap-2">
              <div className="w-2 h-2 bg-white/20 rounded-full"></div>
              <div className="w-2 h-2 bg-white/20 rounded-full"></div>
              <div className="w-2 h-2 bg-white/20 rounded-full"></div>
            </div>

            <div className="relative z-10">
              <p className="text-2xl text-white leading-relaxed mb-12">
                We specialize in developing modern applications for the iOS platform, focusing on security, performance, and user satisfaction. Our products are designed to protect user privacy while delivering exceptional functionality and ease of use.
              </p>

              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-lg">Development Team</p>
                  <p className="text-gray-400">iOS Specialists</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
